import React, { createContext, useContext, useState, useCallback } from "react";
import { isEqual, isFunction } from "lodash";
import { initialFilter } from "./SchCourseWorkInfosUIHelpers";

const SchCourseWorkInfosUIContext = createContext();

export function useSchCourseWorkInfosUIContext() {
  return useContext(SchCourseWorkInfosUIContext);
}

export const SchCourseWorkInfosUIConsumer = SchCourseWorkInfosUIContext.Consumer;

export function SchCourseWorkInfosUIProvider({ schCourseWorkInfosUIEvents, children }) {
  const [queryParams, setQueryParamsBase] = useState(initialFilter);
  const [ids, setIds] = useState([]);
  const setQueryParams = useCallback((nextQueryParams) => {
    setQueryParamsBase((prevQueryParams) => {
      if (isFunction(nextQueryParams)) {
        nextQueryParams = nextQueryParams(prevQueryParams);
      }

      if (isEqual(prevQueryParams, nextQueryParams)) {
        return prevQueryParams;
      }

      return nextQueryParams;
    });
  }, []);

  const value = {
    queryParams,
    setQueryParamsBase,
    ids,
    setIds,
    setQueryParams,
    newSchCourseWorkInfoButtonClick: schCourseWorkInfosUIEvents.newSchCourseWorkInfoButtonClick,
    openEditSchCourseWorkInfoPage: schCourseWorkInfosUIEvents.openEditSchCourseWorkInfoPage,
    openDeleteSchCourseWorkInfoDialog: schCourseWorkInfosUIEvents.openDeleteSchCourseWorkInfoDialog,
    openDeleteSchCourseWorkInfosDialog: schCourseWorkInfosUIEvents.openDeleteSchCourseWorkInfosDialog,
    openFetchSchCourseWorkInfosDialog: schCourseWorkInfosUIEvents.openFetchSchCourseWorkInfosDialog,
  };

  return (
    <SchCourseWorkInfosUIContext.Provider value={value}>
      {children}
    </SchCourseWorkInfosUIContext.Provider>
  );
}
